(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gd-hero-slider')) {
    class GDHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hero-track]');
        this.slides = Array.from(this.track ? this.track.children : []).filter((el) => el.hasAttribute('data-hero-slide'));
        if (this.slides.length < 2) return;
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.index = Math.max(0, this.slides.findIndex((el) => el.classList.contains('is-active')));
        this.interval = parseInt(this.dataset.interval, 10) || 7000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.playing = this.dataset.autoplay === 'true' && !reduced;
        this.held = false;

        const prev = this.querySelector('[data-hero-prev]');
        const next = this.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.heroDot, 10), true)));
        if (this.pauseButton) this.pauseButton.addEventListener('click', () => (this.playing ? this.stop() : this.start()));

        this.addEventListener('mouseenter', () => this.hold(true));
        this.addEventListener('mouseleave', () => this.hold(false));
        this.addEventListener('focusin', () => this.hold(true));
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.hold(false); });

        let startX = null;
        this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 45) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });

        document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(this.timer) : this.schedule()));
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.findIndex((el) => el.contains(event.target));
          if (i > -1) { this.stop(); this.go(i); }
        });

        this.render();
        this.schedule();
      }

      go(i, fromUser) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.render();
        if (fromUser) this.schedule();
      }

      render() {
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
        this.dots.forEach((dot, i) => (i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
        if (this.track) this.track.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        if (this.pauseButton) {
          this.pauseButton.classList.toggle('is-paused', !this.playing);
          this.pauseButton.setAttribute('aria-label', this.playing ? this.pauseButton.dataset.labelPause : this.pauseButton.dataset.labelPlay);
        }
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.playing || this.held || document.hidden) return;
        this.timer = setTimeout(() => { this.go(this.index + 1); this.schedule(); }, this.interval);
      }

      start() { this.playing = true; this.render(); this.schedule(); }
      stop() { this.playing = false; clearTimeout(this.timer); this.render(); }
      hold(value) { this.held = value; value ? clearTimeout(this.timer) : this.schedule(); }
      disconnectedCallback() { clearTimeout(this.timer); }
    }
    customElements.define('gd-hero-slider', GDHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
